import { URL } from "./url";
import PostClient from "../pages/client/Post";
import Home from "../pages/client/Home";
import ManageUser from "../pages/admin/ManageUser/ManageUser";
import LoginPage from "../pages/client/Auth/Login";
import RegisterPage from "../pages/client/Auth/Register";
import Post from "../pages/admin/post/post";
import ManageCategory from "../pages/admin/category";
import AdminDashboard from "../pages/admin/dashboard";
import About from "../pages/client/Podcast";
import PostDetails from "../pages/components/PostDetails/PostDetails";
import CategoryDetails from "../pages/components/CategoryDetails/CategoryDetails";
import ManageRole from "../pages/admin/role";
import ManagePermission from "../pages/admin/permission";
import EmailFollow from "../pages/admin/EmailFollow/EmailFollow";
import ManagePodcast from "../pages/admin/podcast";
import ManageUpload from "../pages/admin/upload";

const publicRouters: any[] = [
  // default layout
  { path: URL.CLIENT.LOGIN, component: LoginPage },
  { path: URL.CLIENT.REGISTER, component: RegisterPage },
  {
    path: URL.CLIENT.POST_DETAIL,
    component: PostDetails,
    changeLayout: "headerOnly",
  },
  {
    path: URL.CLIENT.CATEGORY_DETAIL,
    component: CategoryDetails,
    changeLayout: "headerOnly",
  },
 
  // sidebar layout
  {
    path: URL.CLIENT.POST,
    component: PostClient,
    changeLayout: "sidebarLayout",
  },
  { path: URL.CLIENT.HOME, component: Home, changeLayout: "sidebarLayout" },
  { path: URL.CLIENT.PODCAST, component: About, changeLayout: "sidebarLayout" },
  // layout admin
  {
    path: URL.ADMIN.USER_MANAGER,
    component: ManageUser,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.POST_MANAGER,
    component: Post,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.PODCAST_MANAGER,
    component: ManagePodcast,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.UPLOAD_MANAGER,
    component: ManageUpload,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.CATEGORY_MANAGER,
    component: ManageCategory,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.ADMIN_DASHBOARD,
    component: AdminDashboard,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.ROLE_MANAGER,
    component: ManageRole,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.PERMISSION_MANAGER,
    component: ManagePermission,
    changeLayout: "adminLayout",
  },
  {
    path: URL.ADMIN.EMAIL_FOLLOW_MANAGER,
    component: EmailFollow,
    changeLayout: "adminLayout",
  },
];
const privateRoutes: any[] = [];

export { publicRouters, privateRoutes };
